import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FilterBadWords from 'bad-words';
import filipinoBadWords from 'filipino-badwords-list';
import firebase from "firebase/app";
import "firebase/database";
import { ChatFeed, Message } from 'react-chat-ui'
import CustomBubble from './CustomBubble';
import { ADMIN_ID } from './config';
import './chat.css';

export {
  ADMIN_ID
}

const firebaseConfig = process.env.NODE_ENV === 'production' ? {
  apiKey: "AIzaSyDsnJombqAgImzN0wYixu8-QS9znQseiTE",
  authDomain: "msys-megov.firebaseapp.com",
  databaseURL: "https://msys-megov.firebaseio.com",
  projectId: "msys-megov",
  storageBucket: "msys-megov.appspot.com",
  messagingSenderId: "124765713736",
  appId: "1:124765713736:web:c61a05c0c7769bade76f7d",
  measurementId: "G-4J8CLJB6Z2"
} : 
{
  apiKey: "AIzaSyCf3-Ofc2frK3eudh28KizbraEcVGyu9q4",
  authDomain: "gomanila-chat-support.firebaseapp.com",
  databaseURL: "https://gomanila-chat-support.firebaseio.com",
  projectId: "gomanila-chat-support",
  storageBucket: "gomanila-chat-support.appspot.com",
  messagingSenderId: "589497442088",
  appId: "1:589497442088:web:f1c6e2a5433d0b060cba1d",
  measurementId: "G-SQT03R6FFM"
};
// Initialize Firebase
const fb = firebase.initializeApp(firebaseConfig);
export const fbDB = fb.database();

const removeBadWords = new FilterBadWords()
removeBadWords.addWords(...filipinoBadWords.array)

const Chat = ({ room }) => {

  const [message, setMessage] = useState({
    id: ADMIN_ID,
    message: '',
    senderName: ADMIN_ID
  })

  const [messages, setMessages] = useState([
    new Message({
      id: ADMIN_ID,
      message: "HI I'm Go Manila Support, How can i help you!",
      senderName: ADMIN_ID
    })
  ])

  const onSubmit = e => {
    e.preventDefault()
    
    // fbDB.ref(`rooms/${room}`).update({
    //   date_time: firebase.firestore.Timestamp.fromDate(new Date())
    // })

    fbDB.ref(`rooms/${room}/messages`).push({
      ...message,
      message: removeBadWords.clean(message.message),
      // date_time: firebase.firestore.Timestamp.fromDate(new Date())
    })

    return setMessage({
      ...message,
      message: ''
    })
  }

  const onChangeText = e => {
    setMessage({
      ...message,
      [e.target.name]: e.target.value
    })
  }

  useEffect(() => {
    if(room){
      const messageList = fbDB.ref(`rooms/${room}/messages`)
      messageList.on('value', (snapshot) => {
        if(snapshot.val())
          setMessages([
            ...Object.values(snapshot.val())
          ])
      })
    }

  }, [room])

  return (
    <>
      <h2>Chat with Us!</h2>
      <div className="p-2 chat-feed">
        <ChatFeed
          chatBubble={CustomBubble}
          maxHeight="calc(100vh - 215px)"
          messages={messages} 
          isTyping={false} 
          hasInputField={false} 
          showSenderName={false}
          bubblesCentered
          bubbleStyles={
            {
              text: {
                fontSize: 14
              },
              chatbubble: {
                borderRadius: 70,
                padding: 10
              }
            }
          }
        />
      </div>
      <form onSubmit={onSubmit}>
        <input 
          style={{ height: 40 }}
          autoComplete='off'
          name="message"
          onChange={onChangeText}
          placeholder="Type a message..."
          type="text"
          className="form-control mb-2 chat-input"
          value={message.message}
        />
      </form>
    </>
  )
}

Chat.propTypes = {
  room: PropTypes.string.isRequired
}

export default Chat